import { render, staticRenderFns } from "./ListaMarcas.vue?vue&type=template&id=7d0327b8&scoped=true&"
import script from "./ListaMarcas.vue?vue&type=script&lang=js&"
export * from "./ListaMarcas.vue?vue&type=script&lang=js&"
import style0 from "./ListaMarcas.vue?vue&type=style&index=0&id=7d0327b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0327b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCheckbox,VList,VListItem,VListItemContent,VSkeletonLoader})
